/**
 * Created by MinhQuan on 2/3/2016.
 */

angular.module('taric.model.nomenclature',['common.helper', 'ngResource']).factory('QueryNomenclature', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/sbn/nomenclatures/search', {}, {
        query: {
            method: 'GET',
            isArray: false
        },
        getSectionChilds: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/sbn/sections/:sid'
        },
        getNomenclatureChilds: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/sbn/nomenclatures/:sid'
        },
        getLinks: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/sbn/links'
        }
    });
}).service('SearchByNomenclatureModel', function($q, QueryNomenclature, $rootScope, $translate, CONSTANTS, CommonHelper){
    var model = this;
    var searchCriteria = {};

    model.getSearchCriteria = function (){
        return searchCriteria;
    };
    model.resetSearchCriteria = function(){
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.language = CommonHelper.getLanguageCode($translate.use());
        searchCriteria.direction = 'I';
        searchCriteria.expandAll = false;
    };
    model.resetSearchCriteria();

    model.searchGoodsNomenclature = function(commodityCode, tradeDirection, simulationDate, language){
        var deferred = $q.defer();
        commodityCode = CommonHelper.removeSpaceCharacters(commodityCode);

        //Identify the commodity code to query against the ws
        var queryCommodityCode = commodityCode;

        //Remove trailing zeros if user searches for commodity code that has equal or greater than 8 digits
        var trailingDigits = queryCommodityCode.substring(queryCommodityCode.length - 2);
        while  (trailingDigits === "00" && queryCommodityCode.length >= 8){
            queryCommodityCode = queryCommodityCode.substring(0, queryCommodityCode.length -2);
            trailingDigits = queryCommodityCode.substring(queryCommodityCode.length - 2);
        }

        //Remove the next 2 digits if the query commodity code has more than 6 digits
        if (queryCommodityCode.length >= 6){
            queryCommodityCode = queryCommodityCode.substring(0, queryCommodityCode.length - 2);
        }
        var result = QueryNomenclature.query({
            code: queryCommodityCode,
            tradedirection: tradeDirection,
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            language: language
        }, function () {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getSectionChilds = function (sid, tradeDirection, simulationDate, language) {
        var deferred = $q.defer();
        var result = QueryNomenclature.getSectionChilds({
            sid: sid,
            tradedirection: tradeDirection,
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            language: language
        }, function () {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    
    model.getNomenclatureChilds = function (sid, tradeDirection, simulationDate, language) {
        var deferred = $q.defer();
        var result = QueryNomenclature.getNomenclatureChilds({
            sid: sid,
            tradedirection: tradeDirection,
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            language: language
        }, function () {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getLinks = function(simulationDate) {
        var deferred = $q.defer();
        var result = QueryNomenclature.getLinks({
            simulationdate: CommonHelper.getRestDateString(simulationDate)
        }, function () {
            deferred.resolve(result);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };
}).service('GoodsNomenclatureTreeModel', function(CommonHelper, CONSTANTS){
    var model = this;

    /**
     * Add classifications and child nodes of the selected node to the gono tree
     * @param node The selected node
     * @param index The position of the selected node
     * @param nodeDetails Data containing information of classifications and child nodes of the selected node
     * @param treeDataList The list of current tree nodes in the form of table rows
     */
    model.addClassificationAndChildNodesToGonoTree = function(node, index, nodeDetails, treeDataList){
        var classLinks = model.createClassificationLinks(nodeDetails.classificationLinks, node.item.level + 1);
        if (classLinks.length > 0){
            var classInfo = classLinks[0];

            //Add a new reference to the classInfo
            node.classInfo = classInfo;

            //Add the array of classification links to gono tree
            model.addToGonoTree(classLinks, index + 1, treeDataList);
        }
        node.childItems = nodeDetails.childItems;
        node.childItems.forEach(function(childNode){
            model.updateNomenclatureCodeIndents(childNode);
            model.appendExportRefundAdditionalCodeToDescription(childNode);
        });

        //Add the array of child nodes to gono tree
        model.addToGonoTree(nodeDetails.childItems, classLinks.length + index + 1, treeDataList);

        //Expand or collapse a node in the goods nomenclature tree
        model.expandCollapseGonoTreeNode(node, index, treeDataList);
    };

    model.createClassificationLinks = function(classificationLinks, startLevel) {
        var result = [];

        if (!classificationLinks || classificationLinks.length === 0){
            return result;
        }

        //First, create the node 'Classification Info'
        var gonoTreeClassInfo = {
            state : {isDisplayed: true, isExpanded: false},
            item: {type: 'ClassificationInfo', declarable: false, level: startLevel, description: 'Classification Info'},
            childItems: []
        };
        result.push(gonoTreeClassInfo);
        classificationLinks.forEach(function(classLink){
            var gonoTreeClassLink = {
                state : {isDisplayed: false, isExpanded: false},
                item: classLink
            };
            gonoTreeClassLink.item.type = 'ClassificationLink';
            gonoTreeClassLink.item.childItems = [];
            gonoTreeClassLink.item.declarable = true;
            gonoTreeClassLink.item.level = startLevel + 1;
            gonoTreeClassInfo.childItems.push(gonoTreeClassLink);
            result.push(gonoTreeClassLink);
        });

        return result;

    };
    /**
     * Expand or collapse the selected gono tree node
     * @param node The selected node
     * @param index The position of the selected node
     * @param treeDataList The list of current tree nodes in the form of table rows
     */
    model.expandCollapseGonoTreeNode = function(node, index, treeDataList) {
        if (node.state.isExpanded) {

            //Display Classification Info if it exists
            if (node.classInfo){
                node.classInfo.state = {isDisplayed: true, isExpanded: false};
            }

            //Display all the child nodes
            node.childItems.forEach(function (childNode) {
                childNode.state = {isDisplayed: true, isExpanded: false};
            });
        } else {

            //Find all descendant nodes and hide them
            for (let i = index + 1; i < treeDataList.length; i++) {
                var tempNode = treeDataList[i];
                if (tempNode.item.level <= node.item.level) {
                    break;
                }

                //Hide all descendant nodes
                tempNode.state = {isDisplayed: false, isExpanded: false};

            }
        }

    };

    /**
     * Add to gono tree (in the form of a table) a list of nodes from the position index
     * @param nodes The given list of nodes to be added
     * @param index The position that the first node of the given list will be added
     * @param treeDataList The list of current tree nodes in the form of table rows
     */
    model.addToGonoTree = function(nodes, index, treeDataList){
        if(index > treeDataList.length){
            return;
        }
        nodes.forEach(function(node){
            treeDataList.splice(index++, 0, node);
        });
    };

    /**
     * Get the css class of a tree node based on its level
     * @param node The given node
     * @returns The class name
     */
    model.getTreeNodeClass = function (node) {
        return "indent_level_" + node.item.level;
    };


    /**
     * Build up the gono tree in the form of table rows based on a list of tree nodes
     * @param nodes The given list of tree nodes
     * @param commodityCode The commodity code in the search criteria
     * @return An array of table rows forming the target gono tree
     */
    model.buildGonoTree = function(nodes, commodityCode, expandAll){
        var result = [];
        if (!nodes){
            return result;
        }
        nodes.forEach(function(node){
            result = result.concat(model.convertTreeNodeToTableRows(node));
        });

        //Remove space characters
        commodityCode = CommonHelper.removeSpaceCharacters(commodityCode);

        //If commodityCode is not specified, then display a list of sections
        if (commodityCode === ""){
            result.forEach(function(node){
                node.state = {isExpanded: false, isDisplayed: true};
            });
        } else {
            var i, currentNode, parentNode;

            //Find exact matching commodity codes that user is searching for and open all its children - Store the first matching commodity code node for later use
            var firstMatchingCommodityCodeNode = null;
            var firstMatchingCommodityCodePos = 0;
            var trailingDigits = null;
            var shouldContinueToCheck = false;
            do {
                shouldContinueToCheck = false;
                for (let i = 0; i < result.length; i++){
                    currentNode = result[i];
                    if (currentNode.item.code === commodityCode){

                        //Always open the nodes that has the exact match with the given commodity code
                        currentNode.state = {isExpanded: true, isDisplayed: true};

                        //Display all of its children
                        currentNode.childItems.forEach(function (childNode) {
                            childNode.state = {isExpanded: false, isDisplayed: true};
                        });

                        if (firstMatchingCommodityCodeNode === null){
                            firstMatchingCommodityCodeNode = currentNode;
                            firstMatchingCommodityCodePos = i;
                        }
                    }
                }

                if (firstMatchingCommodityCodeNode === null && commodityCode.length >= 4){

                    //Remove the trailing '00' to find the matching commodity code
                    trailingDigits = commodityCode.substring(commodityCode.length - 2);
                    if (trailingDigits === "00"){
                        commodityCode = commodityCode.substring(0, commodityCode.length -2);
                        shouldContinueToCheck = true;
                    }
                }
            } while(firstMatchingCommodityCodeNode === null && shouldContinueToCheck);

            //The commodity code is not found, find the commodity code starting with the commodity code that user has entered
            if (firstMatchingCommodityCodeNode === null){
                for (let i = 0; i < result.length; i++){
                    currentNode = result[i];
                    if (currentNode.item.code && currentNode.item.code.indexOf(commodityCode) === 0){

                        //Always open the nodes that has the exact match with the given commodity code
                        currentNode.state = {isExpanded: true, isDisplayed: true};

                        //Display all of its children
                        currentNode.childItems.forEach(function (childNode) {
                            childNode.state = {isExpanded: false, isDisplayed: true};
                        });

                        if (firstMatchingCommodityCodeNode === null){
                            firstMatchingCommodityCodeNode = currentNode;
                            firstMatchingCommodityCodePos = i;
                        }
                    }
                }
            }

            //The commodity code is not found, show error message
            if (firstMatchingCommodityCodeNode === null) {
                return null;
            }

            if(expandAll){
                for (let i = 0; i < result.length; i++) {
                    result[i].state = {isExpanded: true, isDisplayed: true};
                }
            } else {

                //Display the tree path from the root node to the first commodity code node found - Display all the child nodes on the path
                currentNode = firstMatchingCommodityCodeNode;
                do {
                    parentNode = currentNode.parent;

                    //Display the parent and its children
                    parentNode.state = {isExpanded: true, isDisplayed: true};
                    if (parentNode.childItems){

                        //Display all of its children
                        parentNode.childItems.forEach(function (childNode) {
                            if (!childNode.state){
                                childNode.state = {isExpanded: false, isDisplayed: true};
                            } else {
                                childNode.state.isDisplayed = true;
                            }
                        });
                    }

                    currentNode = parentNode;
                } while (parentNode !== result[0]);

                //If user is searching for a commodity code which has more than or equal to 4 digits,
                // all the commodity codes which have 6 digits under the first matching commodity code should also be displayed
                for (let i = 0; i < result.length; i++){
                    currentNode = result[i];

                    //Commodity codes under the first matching commodity code
                    if (i > firstMatchingCommodityCodePos){

                        //Stop processing when it comes to the successor sibling node
                        if (currentNode.item.level <= firstMatchingCommodityCodeNode.item.level){
                            break;
                        }
                        if ((commodityCode.length >= 4 && currentNode.item.code.length === 6)) {

                            //Display all of children of the current's parent node.
                            currentNode.parent.childItems.forEach(function (childNode) {
                                if (!childNode.state){
                                    childNode.state = {isExpanded: false, isDisplayed: true};
                                } else {
                                    childNode.state.isDisplayed = true;
                                }
                            });

                            //Open the parent node when we show the child node
                            currentNode.parent.state.isExpanded = true;
                        }
                    }
                }

            }
        }
        return result;
    };

    /**
     * Convert a tree node and all of its descendants to an array of table rows
     * @param node The tree node to be converted
     * @returns An array of table rows
     */
    model.convertTreeNodeToTableRows = function (node){
        var result = [];

        //Add the node itself to the result
        result.push(node);

        //Add the dashes before node's description if it is a 'NomenclatureCode' node
        model.updateNomenclatureCodeIndents(node);

        //Append export refund additional code to description
        model.appendExportRefundAdditionalCodeToDescription(node);

        //Add the classification links to the result
        if (node.classificationLinks.length > 0){
            var classLinks = model.createClassificationLinks(node.classificationLinks, node.item.level + 1);

            if (classLinks.length > 0){
                var classInfo = classLinks[0];

                //Add a new reference to the classInfo
                node.classInfo = classInfo;

                //Add the array of classification links to the result
                result = result.concat(classLinks);
            }
        }

        //Recursively convert child nodes to table rows and add them to the result
        if (node.childItems.length > 0){
            node.childItems.forEach(function(childNode){

                //Update the parent property
                childNode.parent = node;
                result = result.concat(model.convertTreeNodeToTableRows(childNode));
            });
        }
        return result;
    };

    /**
     * Append export refund additional code to description
     * @param node The given node
     */
    model.appendExportRefundAdditionalCodeToDescription = function(node){
        if(node.item.declarable && node.item.exportrefundcode){
            node.item.description = node.item.description + "(" + node.item.exportrefundcode + ")";
        }
    };

    /**
     * Add the dashes before node's description if it is a 'NomenclatureCode' node
     * @param node The given node
     */
    model.updateNomenclatureCodeIndents = function(node){
        if (node.item.level > 2 && node.item.type === 'NOMENCLATURECODE'){
            let numberOfDashes = node.item.level - 2;
            // ITESUP-41: Decrease numberOfDashes to keep the number of DASH unchanged for nodes belonging to a sub-chapter
            if (node.item.increasedIndent) {
                numberOfDashes--;
            }
            let prefix = "";
            let count = 0;
            while (numberOfDashes > 0){
                prefix = prefix + "- ";
                count = count + 1;
                if (CONSTANTS.gonoTree.formatIndents){
                    if (count % 3 === 0 && numberOfDashes > 1){
                        prefix = prefix + "&nbsp;";
                    }
                }
                numberOfDashes--;
            }
            node.item.description = prefix + node.item.description;
        }
    };
});


// WEBPACK FOOTER //
// ./app/taric/nomenclature/shared/nomenclature-model.js